module.exports = __webpack_public_path__ + "static/media/support.c0672c4e.svg";